export const getters = {
  getModalViewFormaDePagamento: state => state.modalViewFormaDePagamento,
  getFormasDePagamentos: state => state.formasDePagamentos,
  getFormaDePagamento: state => state.formaDePagamento,
  getFormaDePagamentoMarcadas: state => state.formaDePagamentoMarcadas
};

export default {};
